import { component } from 'flightjs';
function WindowResize() {
    this._triggerLoad = function () {
        this.trigger(document, 'utils:window-load');
    };

    this.after('initialize', function () {
        if (
            document.readyState &&
            (document.readyState === 'complete' ||
                document.readyState.state === 'complete')
        ) {
            this._triggerLoad();
        } else {
            this.on(window, 'load', this._triggerLoad);
        }
    });
}

export default component(WindowResize);
